import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { ItineraryService } from '../../itinerary.service';
import { CookieService } from 'ngx-cookie';
@Component({
  selector: 'usb-modal-insurance',
  templateUrl: './modal-insurance.component.html',
  styleUrls: ['./modal-insurance.component.scss'],
  providers: [DatePipe]
})
export class ModalInsuranceComponent implements OnInit {

  _findData

  @Input() modalRoomRef: any;
  @Input() insurance: any;
  @Input() form: FormGroup;
  @Input() payloadUpdate?: any;
  @Input() itineraryItem?: any;
  @Input() origin?: any;
  @Input() arrayResults?: any;
  @Input() clientSetting: any;
  @Input() payload?: any;
  @Output() refModal = new EventEmitter<any>();
  Adultts: number;
  Childs: number;
  Origen: string;
  Destino: string;


  constructor(private itineraryService: ItineraryService, private dateEnd: DatePipe, private _cookieService: CookieService) { }

  ngOnInit() {
  }

  close() {
    this._emitRefModal('');
  }

  _emitRefModal(status: string) {
    this.refModal.emit(status);
  }

}
